export default class FormError {

  static defaultOptions = {
    classes: {
      invalid: 'input_invalid',
      errorMessage: 'error-message'
    },
    errorElement : 'span'
  }

  #options  = {};
  #form     = null;
  #error    = null;
  #input    = null;
  #wrapper  = null;
  #errorMessageEl = null;
  #eventListener = {};

  constructor( form, error, options = {} ) {
    this.#options  = { ...this.constructor.defaultOptions, ...options };
    this.#form    = form;
    this.#error   = error;
    this.#input   = form.querySelector( `[name="${ this.#error.field }"` );
    this.#wrapper = this.#input.parentElement;
    this.addClass();
    this.addMessage();
  }
  
  addClass() {
    this.#wrapper.classList.add( this.#options.classes.invalid );
  }

  removeClass() {
    this.#wrapper.classList.remove( this.#options.classes.invalid );
  }
  
  addMessage() {
    this.#errorMessageEl = document.createElement( this.#options.errorElement );
    this.#errorMessageEl.classList.add( this.#options.classes.errorMessage );
    this.#errorMessageEl.innerHTML = this.#error.message;
    this.#wrapper.appendChild( this.#errorMessageEl );
  }

  removeMessage() {
    this.#errorMessageEl.remove();
  }

  addEventListener( type, listener, obj ) {
    this.#eventListener.type = type;
    this.#input.addEventListener( type, this.#eventListener.reference = listener.bind( obj ) )
  }

  removeEventListener() {
    this.#input.removeEventListener( this.#eventListener.type, this.#eventListener.reference );
  }
  
  destroy() {
    this.removeClass();
    this.removeMessage();
    this.removeEventListener();
  }

}